import React from 'react';

export function CustomTickSkeleton(props: any) {
    const {x, y, fill} = props;
    return <circle cx={x} cy={y} r={1} fill={fill} />;
}
